var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import EventBus from "../../events/EventBus";
import { addGlobalLiveEventListener } from "../../utils";
import { useSetsApi } from "../user_sets/api";
var constructorStatus = 'create';
export function initConstructorCards() {
    var _this = this;
    addGlobalLiveEventListener('click', '.js-add-to-set', function (event) { return __awaiter(_this, void 0, void 0, function () {
        var button, offerId;
        return __generator(this, function (_a) {
            button = event.target;
            offerId = parseInt(button.getAttribute('data-offer-id'));
            handleAddToSetButtonClick(offerId, button, button.dataset.name || '');
            return [2 /*return*/];
        });
    }); });
}
export function handleAddToSetButtonClick(offerId, button, name) {
    return __awaiter(this, void 0, void 0, function () {
        var labelSpan, originalText, response, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!button || button.disabled) {
                        return [2 /*return*/];
                    }
                    if (!offerId) {
                        return [2 /*return*/];
                    }
                    labelSpan = button.querySelector('.btn__label');
                    originalText = labelSpan ? labelSpan.textContent : 'В сет';
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    button.disabled = true;
                    return [4 /*yield*/, useSetsApi().addItem(offerId)];
                case 2:
                    response = _b.sent();
                    if (response.ok) {
                        if (labelSpan) {
                            labelSpan.textContent = 'Добавлено';
                        }
                        EventBus.emit('set:update', response.data);
                        setTimeout(function () {
                            if (constructorStatus !== 'full' && labelSpan && labelSpan.textContent === 'Добавлено') {
                                labelSpan.textContent = originalText;
                                button.disabled = false;
                            }
                        }, 1000);
                    }
                    else {
                        if (response.error.limit) {
                            EventBus.emit('set:replacement-requested', {
                                id: offerId,
                                name: name,
                            });
                        }
                        else {
                            console.warn((_a = Object.values(response.error)[0]) !== null && _a !== void 0 ? _a : 'Ошибка добавления');
                            // TODO (toast): Показать ошибку добавления в сет (errorMessage)
                        }
                        if (constructorStatus !== 'full') {
                            button.disabled = false;
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error(e_1);
                    // TODO (toast): Показать системную ошибку/сетевой сбой ('Произошла системная ошибка при добавлении в сет')
                    if (constructorStatus !== 'full') {
                        button.disabled = false;
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function lockAddToSetButtons(initialStatus) {
    function setButtonsDisabledState(isFull) {
        var buttons = document.querySelectorAll('.js-add-to-set');
        buttons.forEach(function (btn) {
            var label = btn.querySelector('.btn__label');
            if (isFull) {
                btn.disabled = true;
                btn.classList.add('btn--gray');
                btn.classList.remove('btn--black');
                if (label) {
                    label.textContent = 'Лимит сетов';
                }
            }
            else {
                if (label && label.textContent === 'Лимит сетов') {
                    btn.disabled = false;
                    btn.classList.remove('btn--gray');
                    btn.classList.add('btn--black');
                    label.textContent = 'В сет';
                }
            }
        });
    }
    if (initialStatus) {
        constructorStatus = initialStatus;
    }
    // 1. Первоначальная установка при загрузке
    if (constructorStatus === 'full') {
        setButtonsDisabledState(true);
    }
    // 2. Обновление при изменении состава сета через EventBus
    EventBus.on('set:update', function (data) {
        if (data && data.status) {
            constructorStatus = data.status;
            setButtonsDisabledState(constructorStatus === 'full');
        }
    });
    // 3. Блокировка новых кнопок при AJAX-обновлении товаров (фильтры, пагинация)
    EventBus.on('products:load', function () {
        if (constructorStatus === 'full') {
            setButtonsDisabledState(true);
        }
    });
}
